export class NTUserInboxAPIModel  {
  GetNTUserInboxListAPI: string = "";
  DownloadNTUserArticleFile: string = "";
  UploadUserCompletedApi: string = "";
  NTUserCompletedApi: string = "";
  StartNTUserAPI: string = "";
  GetNextActivity: string = "";
  ArticleListAPI: string = "";

  TransactionAPI: string = "";
  TransactioDetailsAPI: string = "";
  
  UpdateNotes: string = "";
  UploadTransactionFile: string = "";
  DownloadTransactionFile: string = "";
  UpdateTransactionAPI: string = "";
  VolumeIssueListAPI: string = "";
  GetJournalList: string = "";
  FailedMsg: string = "";
  SelectFileErrorMsg: string = "";
  UploadFileMsg: string = "";
  RevertNTUserAPI: string = "";
  LargeUpload: string = "";
}
